import { WorkOrdersRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    work_orders: [],
    interventions: []
  },
  mutations: {
    getOrders (state, data) {
      state.work_orders = []
      state.work_orders = data
    },
    getInterventions (state, data) {
      state.interventions = []
      state.interventions = data
    }
  },
  actions: {
    // Get
    getOrders ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('getOrders', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getInterventions ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.getInterventions(obj)
          .then(response => {
            const data = response.data.data
            commit('getInterventions', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get (context, obj) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.get(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    // Actions    
    createOrder (context, order) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.create(order)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editOrder (context, order,) {      
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.update(order)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    uploadFile (context, upload) {
      const formData = new FormData();
      formData.append('file_attachment', upload.fileToUpload)
      upload.file = formData

      return new Promise((resolve, reject) => {
        WorkOrdersRepository.uploadFile(upload)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
    deleteFile (context, file) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.deleteFile(file)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
    deleteOrder (context, id) {
      return new Promise((resolve, reject) => {
        WorkOrdersRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
